
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserTypeState {
  userSelectedType: "donor" | "charity";
}

const initialState: UserTypeState = {
  userSelectedType: "donor",
};

const userSelectSlice = createSlice({
  name: "userSelectedType",
  initialState,
  reducers: {
    setUserSelectedType(state, action: PayloadAction<"donor" | "charity">) {
      state.userSelectedType = action.payload;
    },
  },
});

// Export the action to change userType
export const { setUserSelectedType } = userSelectSlice.actions;

// Export the reducer
export default userSelectSlice.reducer;
